var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('the-header',{attrs:{"title":_vm.t(_vm.createUser ? 'Create sub-user': 'Edit sub-user')}}),_vm._v(" "),_c('titan-form',{attrs:{"schema":_vm.schema,"newItem":_vm.createUser,"model":_vm.modelData,"editable":_vm.editable},on:{"saveData":function($event){return _vm.saveData()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6ab1c38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/private/subuser/Manage.vue
// module id = null
// module chunks = 